import { useState, useEffect } from "react";
import { brandService } from "../../services/BrandService";

function useBrand(page: number | undefined): [any, boolean] {
  const [result, setResult] = useState({
    brands: [],
    hasMore: true,
    cursor: "",
    total: 0,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      try {
        if (result.hasMore) {
          setLoading(true);
          const res = await brandService.getAll(page ? page : 1);
          if (res.status !== 200) {
            throw new Error("Failed to fetch!");
          } else {
            setResult(res.data);
          }
        }
      } catch (err: any) {
        const error = err.toString();
        //message.error(error);
        console.log(error)
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return [result, loading];
}

export default useBrand;
